export default {"src":"/_next/static/media/copy-icon.59d1afdf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};